<template>
  <span class="sort-arrow-container">
    <icon v-if="sortMethod !== activeMethod" name="order" />
    <template v-else class="active">
      <icon v-if="sortDirection === 'desc'" :name="downName" class="active" />
      <icon v-else :name="upName" class="active" />
    </template>
  </span>
</template>

<script>
import Icon from 'com/Icon'
export default {
  name: 'OrderDirection',
  components: {
    Icon
  },
  props: {
    sortDirection: String,
    sortMethod: String,
    activeMethod: String
  },
  computed: {
    theme() {
      return this.$store.state.settings.theme
    },
    upName() {
      return this.theme ? 'up-' + this.theme : 'up-theme-dark'
    },
    downName() {
      return this.theme ? 'down-' + this.theme : 'down-theme-dark'
    }
  }
}
</script>

<style lang="less" scoped>
.sort-arrow-container {
  display: inline-block;
  vertical-align: middle;
  .icon {
    width: 7px;
    height: 12px;
    cursor: pointer;
    margin-top: -2px;
    margin-left: 2px;
  }
}
</style>
